// @flow
import React from 'react';
import { MdDelete, MdKeyboardArrowDown } from 'react-icons/lib/md';
import i18n from 'i18n-js';

import Button from '../../Button';
import { Search } from '../../CommonTexts';
import styles from './scheduleTable.css';


export const SelectPlaceHolder = () => (
  <td className={styles.routeStop}>
    <div className={styles.placeholder}>
      <div>
        {'Busca una parada aquí'}
      </div>
      <Button
        Icon={MdKeyboardArrowDown}
        isTransparent
        clearMargins
      />
    </div>
  </td>
);


const RouteStop = ({
  id,
  name,
  route,
  onClick,
}) => (
  <td className={styles.routeStop}>
    <Button
      Icon={MdDelete}
      isTransparent
      clearMargins
      onClick={() => onClick()}
    />
    <div className={styles.stopDescription}>
      <div className={styles.route}>{route}</div>
      <div>{name}</div>
    </div>
  </td>
);

export default RouteStop;



// WEBPACK FOOTER //
// ./src/scripts/components/StudentStopsScheduling/ScheduleTable/routeStop.jsx